import React, { Fragment } from 'react';
import { Footer } from './footer';
import {Popup, UI, Collaboration } from 'components';
import {moment, useNamedSelector} from 'helpers';
import css from './weekly-objectives.scss';
import {toggle as toggleActivities} from "store/activities";
import {goals} from 'store';
import {WeeklyObjectiveContextMenu} from "./context-menu";

export function Card(props) {
  const { id, Checkbox, detailed, ...restProps } = props;
  const details = useNamedSelector('goals.details', { id, context: 'goals' });
  const { goal, editable, timeframe, disabled, activities: goalActivities } = details;
  const { status: goalStatus, name: goalName, note: goalNote } = goal;

  const { Card } = UI;
  const { Checkbox: UICheckbox } = UI;
  const Status = props.Status || Collaboration.CardStatus;
  const ActionMenu = props.ActionMenu || Popup.Menu.Handle;

  const renderActivities = () => (
    <Card.Body>
      <ul className={css.checkList}>
        {goalActivities.map(({ id: activityId, status, name, ts }) => (
          <li key={activityId}>
            <Fragment>
              <UICheckbox
                className={css.checkbox}
                checked={status === 'Completed'}
                onClick={() => toggleActivities({ id: activityId })}
              />
              <span>{name}</span>
              { ts &&
                <Card.Highlight className="pull-right default-color">
                  {moment.unix(ts).format()}
                </Card.Highlight>
              }
            </Fragment>
          </li>
        ))}
      </ul>
    </Card.Body>
  );

  return (
    <Card
      id={id}
      navLink={`/goals/weekly-objectives/${id}/`}
      {...restProps}
      status={goalStatus}
      timeframe={timeframe}
      disabled={disabled}
    >
      <Status selector="goals.details" id={id} />
      <ActionMenu
        id={id}
        editable={true}
        Menu={WeeklyObjectiveContextMenu}
      />
      <Card.Body {...details}>
        <div className={css.weeklyObjectiveLabel}>
          <UICheckbox
            className={css.checkbox}
            checked={goalStatus === 'Completed'}
            onClick={() => goals.dispatch.toggle(goal)}
          />
          <span>{goalName}</span>
        </div>
        <Card.Note is3LinesMax={!detailed}>{goalNote}</Card.Note>
      </Card.Body>
      <Footer goal={goal} {...props} />
      {goalActivities && renderActivities()}
    </Card>
  );
}
